import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CoinIcon } from "@/components/Brand";
import { CheckoutSheet } from "@/components/store/CheckoutSheet";

const GRADS = ["from-[#FF6A00] to-[#EE0979]", "from-[#C026D3] to-[#7C3AED]", "from-[#0EA5E9] to-[#2563EB]"];
const short = (n) => (n >= 1000000 ? `${(n / 1000000).toLocaleString(undefined, { maximumFractionDigits: 2 })}M` : n.toLocaleString());

function Row({ p, grad, onPick }) {
  return (
    <button
      data-testid={`package-${p.id}`}
      onClick={() => onPick(p)}
      className={`group relative w-full grid grid-cols-[1.3fr_1fr_auto] items-center gap-2 rounded-2xl px-4 ${grad ? `bg-gradient-to-r ${grad} py-4 shadow-lg` : "bg-[#1F2633] hover:bg-[#262F3F] py-3"} border border-white/10 text-left transition-[background-color,transform] hover:-translate-y-0.5`}
    >
      <div>
        {p.tag && <span className={`inline-block mb-1 text-[10px] uppercase font-black px-2 py-0.5 rounded-full ${grad ? "bg-black/30 text-white" : "bg-[#10B981]/15 text-[#10B981]"}`}>{p.tag}</span>}
        <div className="flex items-center gap-1.5 font-display font-extrabold text-[15px] sm:text-lg"><CoinIcon cur="gc" size={20} /><span className={grad ? "text-white" : "gc-text"}>{short(p.gc)}</span></div>
      </div>
      <div className="flex items-center gap-1.5 font-display font-bold"><CoinIcon cur="sc" size={18} /><span className={grad ? "text-white" : "sc-text"}>{p.sc.toFixed(2)}</span></div>
      <div className="flex flex-col items-end">
        {p.was && <span className={`text-[11px] line-through ${grad ? "text-white/80" : "text-gray-500"}`} data-testid={`package-was-${p.id}`}>was ${p.was.toFixed(2)}</span>}
        <span className="rounded-xl bg-gradient-to-b from-[#B6FF3B] to-[#3FCB3A] text-[#0B2A0B] px-4 py-2 font-display font-black text-sm shadow-[0_2px_0_#1E7A1E] group-active:translate-y-0.5 transition-transform" data-testid={`package-price-${p.id}`}>${p.price.toFixed(2)}</span>
      </div>
    </button>
  );
}

export function BuyTab() {
  const [pkgs, setPkgs] = useState([]);
  const [sel, setSel] = useState(null);
  useEffect(() => { api.get("/packages").then((r) => setPkgs(r.data)); }, []);
  const featured = pkgs.filter((p) => p.featured);
  const rest = pkgs.filter((p) => !p.featured);

  return (
    <div className="space-y-3" data-testid="buy-tab">
      <div className="grid grid-cols-[1.3fr_1fr_auto] px-4 text-[11px] font-black uppercase tracking-wider text-gray-400">
        <span>Gold Coins</span><span className="text-[#FFB800]">Free SC</span><span className="w-20" />
      </div>
      {featured.map((p, i) => <Row key={p.id} p={p} grad={GRADS[i % 3]} onPick={setSel} />)}
      {rest.map((p) => <Row key={p.id} p={p} onPick={setSel} />)}
      <p className="pt-2 text-xs text-gray-500">First purchase on a new account receives double Gold Coins. Sweeps Coins are always free and included as a bonus.</p>
      <CheckoutSheet pkg={sel} onClose={() => setSel(null)} />
    </div>
  );
}
